<template>
  <v-card elevation="0">
    <v-card-title>Service Favoris</v-card-title>
    <v-card-text>
      <template v-if="loading==false">
        <p class="title">{{service.name}}</p>
        <p>
          <span class="headline font-weight-bold">{{percent}}%</span> des commandes
        </p>
        <v-progress-linear
          :background-opacity="0.3"
          :buffer-value="100"
          :height="20"
          rounded
          :value="percent"
          color="primary"
        ></v-progress-linear>
      </template>
      <v-progress-circular v-else indeterminate color="orange darken-2"></v-progress-circular>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions } from "vuex";

export default {
  data: () => ({
    service: null,
    percent: 0,
    loading: true
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.loading = true;
      this.favoritService()
        .then(data => {
          this.service = data.data.service;
          this.percent = data.data.percent;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    open(id) {
      this.$router.push("/orders/view/" + id);
    },
    ...mapActions("statistique", ["favoritService"])
  }
};
</script>

<style>
</style>